// Explicitly exported here to avoid confusion.
// create-react-app will try to load these from .env files at build time

const ensure = <A>(a?: A): A => {
  if (!a) {
    throw Error('Missing environment variable');
  }
  return a;
};

export const SERVICE_BASE_URL = ensure(process.env.REACT_APP_SERVICE_BASE_URL);
export const BASE_URL = ensure(process.env.REACT_APP_BASE_URL);
export const STRIPE_PUBLIC_KEY = ensure(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
export const CONTACT_EMAIL = ensure(process.env.REACT_APP_CONTACT_EMAIL);
export const CURRENCY = ensure(process.env.REACT_APP_CURRENCY);
export const RELEASE_VERSION = ensure(process.env.REACT_APP_RELEASE_VERSION);
export const RECAPTCHA_API_KEY = ensure(process.env.REACT_APP_RECAPTCHA_API_KEY);
export const VISUAL_INSPECTION_TESTS = ensure(process.env.REACT_APP_VISUAL_INSPECTION_TESTS);
export const GITHUB_STUDENT_APP_CLIENT_ID = ensure(process.env.REACT_APP_GITHUB_STUDENT_APP_CLIENT_ID);

// SSO
export const COGNITO_CLIENT_ID = ensure(process.env.REACT_APP_COGNITO_CLIENT_ID);
export const COGNITO_BASE_URL = ensure(process.env.REACT_APP_COGNITO_BASE_URL);
/**
 * The custom domain we configured in Cognito.
 * Used for public IDPs (e.g. Google SSO) so end-users see our branded domain
 * instead of the default AWS-hosted one.
 */
export const COGNITO_CUSTOM_BASE_URL = ensure(process.env.REACT_APP_COGNITO_CUSTOM_BASE_URL);

/**
 * Unique identifier (client ID) for our Cognito app integration.
 * Required when initiating OAuth2 flows.
 */
export const COGNITO_IDENTIFIER = ensure(process.env.REACT_APP_COGNITO_IDENTIFIER);

// Hubspot
export const HUBSPOT_TRACKING_CODE = ensure(process.env.REACT_APP_HUBSPOT_TRACKING_CODE);
